import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Instagram } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function InstagramCallback() {
  const [params] = useSearchParams();
  const [state, setState] = useState("loading");
  const [username, setUsername] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const code = params.get("code");
    if (!code) {
      setError("Codice di autorizzazione mancante");
      setState("error");
      return;
    }
    api.post("/instagram/exchange", { code })
      .then((r) => {
        setUsername(r.data.username || "");
        setState("ok");
      })
      .catch((err) => {
        setError(formatApiErrorDetail(err.response?.data?.detail));
        setState("error");
      });
  }, [params]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-cream px-4" data-testid="instagram-callback-page">
      <div className="w-full max-w-md rounded-3xl border border-sand bg-white p-8 text-center shadow-lg">
        <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-gradient-to-tr from-amber-400 via-pink-500 to-purple-600 text-white">
          <Instagram className="h-7 w-7" />
        </span>
        {state === "loading" && (
          <div className="mt-6 space-y-3">
            <div className="mx-auto h-10 w-10 animate-spin rounded-full border-4 border-sand border-t-terracotta" />
            <p className="font-display text-lg font-bold text-olive" data-testid="ig-callback-loading">Collegamento di Instagram in corso...</p>
            <p className="text-sm text-stone-500">Non chiudere la pagina, faccio tutto io.</p>
          </div>
        )}
        {state === "ok" && (
          <div className="mt-6 space-y-3">
            <CheckCircle2 className="mx-auto h-12 w-12 text-green-600" />
            <p className="font-display text-xl font-bold text-olive" data-testid="ig-callback-success">Instagram collegato!</p>
            <p className="text-sm text-stone-600">
              L'account <span className="font-semibold">@{username}</span> è collegato a IoEmozione. Da ora i post possono partire in automatico.
            </p>
            <p className="text-xs text-stone-400">Puoi chiudere questa pagina e avvisare Valentina: "fatto!"</p>
          </div>
        )}
        {state === "error" && (
          <div className="mt-6 space-y-3">
            <XCircle className="mx-auto h-12 w-12 text-red-500" />
            <p className="font-display text-xl font-bold text-olive" data-testid="ig-callback-error">Qualcosa non ha funzionato</p>
            <p className="text-sm text-stone-600">{error}</p>
            <p className="text-xs text-stone-400">Fai uno screenshot di questa schermata e invialo nella chat.</p>
          </div>
        )}
        <Link to="/" className="mt-6 inline-block text-xs font-medium text-stone-400 hover:text-olive" data-testid="ig-callback-home-link">
          Torna al sito
        </Link>
      </div>
    </div>
  );
}
